export var AcceptedLanguage;
(function (AcceptedLanguage) {
    AcceptedLanguage["at"] = "at";
    AcceptedLanguage["be"] = "be";
    AcceptedLanguage["bg"] = "bg";
    AcceptedLanguage["cy"] = "cy";
    AcceptedLanguage["cz"] = "cz";
    AcceptedLanguage["de"] = "de";
    AcceptedLanguage["dk"] = "dk";
    AcceptedLanguage["ee"] = "ee";
    AcceptedLanguage["en"] = "en";
    AcceptedLanguage["es"] = "es";
    AcceptedLanguage["fi"] = "fi";
    AcceptedLanguage["fr"] = "fr";
    AcceptedLanguage["gr"] = "gr";
    AcceptedLanguage["hr"] = "hr";
    AcceptedLanguage["hu"] = "hu";
    AcceptedLanguage["ie"] = "ie";
    AcceptedLanguage["it"] = "it";
    AcceptedLanguage["lt"] = "lt";
    AcceptedLanguage["lu"] = "lu";
    AcceptedLanguage["lv"] = "lv";
    AcceptedLanguage["mt"] = "mt";
    AcceptedLanguage["nl"] = "nl";
    AcceptedLanguage["pl"] = "pl";
    AcceptedLanguage["pt"] = "pt";
    AcceptedLanguage["ro"] = "ro";
    AcceptedLanguage["se"] = "se";
    AcceptedLanguage["si"] = "si";
    AcceptedLanguage["sk"] = "sk";
})(AcceptedLanguage || (AcceptedLanguage = {}));
export var SubscriptionEventType;
(function (SubscriptionEventType) {
    SubscriptionEventType["added"] = "added";
    SubscriptionEventType["changed"] = "changed";
    SubscriptionEventType["ready"] = "ready";
    SubscriptionEventType["removed"] = "removed";
})(SubscriptionEventType || (SubscriptionEventType = {}));
export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["WINERY_MEMBER"] = "WINERY_MEMBER";
})(UserRole || (UserRole = {}));
export var WineGeneralDetailsCategory;
(function (WineGeneralDetailsCategory) {
    WineGeneralDetailsCategory["DESSERT_WINE"] = "DESSERT_WINE";
    WineGeneralDetailsCategory["FORTIFIED_WINE"] = "FORTIFIED_WINE";
    WineGeneralDetailsCategory["OTHER"] = "OTHER";
    WineGeneralDetailsCategory["RED_WINE"] = "RED_WINE";
    WineGeneralDetailsCategory["ROSE_WINE"] = "ROSE_WINE";
    WineGeneralDetailsCategory["SPARKLING_WINE"] = "SPARKLING_WINE";
    WineGeneralDetailsCategory["WHITE_WINE"] = "WHITE_WINE";
})(WineGeneralDetailsCategory || (WineGeneralDetailsCategory = {}));
export var WineResponsibleConsumption;
(function (WineResponsibleConsumption) {
    WineResponsibleConsumption["EIGHTEEN_PLUS"] = "EIGHTEEN_PLUS";
    WineResponsibleConsumption["NO_DRIVING"] = "NO_DRIVING";
    WineResponsibleConsumption["NO_PREGNANCY"] = "NO_PREGNANCY";
    WineResponsibleConsumption["WINE_IN_MODERATION"] = "WINE_IN_MODERATION";
})(WineResponsibleConsumption || (WineResponsibleConsumption = {}));
export var WineSustainability;
(function (WineSustainability) {
    WineSustainability["EURO_LEAF"] = "EURO_LEAF";
    WineSustainability["EU_VEGAN"] = "EU_VEGAN";
    WineSustainability["GREEN_DOT"] = "GREEN_DOT";
    WineSustainability["RECYCLE"] = "RECYCLE";
    WineSustainability["TERRA_VITIS"] = "TERRA_VITIS";
    WineSustainability["TRIMAN"] = "TRIMAN";
    WineSustainability["WFCP"] = "WFCP";
    WineSustainability["WFCP_PLUS"] = "WFCP_PLUS";
})(WineSustainability || (WineSustainability = {}));
